import {
  Grid,
  Container,
  makeStyles,
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
} from "@material-ui/core";
import { Drawer, SimpleToolbar, Toast } from "../../../components";
import { ToggleStatus } from "../../../components/toggle-status";
import { ConfirmationDialog } from "../../../components/confirmation-dialog";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useEffect, useRef, useState } from "react";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import RefillCategoryTable from "../../../components/refill/refill-category-table";
import { laboratoryServices } from "../../../services";
import LinkButton from "../../../components/link-button";
export default function RefillScreen() {
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [refillCategories, setRefillCategories] = useState(null);
  const existsBasalCategory = useRef(false);
  const [toast, setToast] = useState({ open: false, message: "" });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    toConfirm: null,
  });
  const { toConfirm: refillCategory } = confirmationDialog;
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const classes = useStyles();

  const handleConfirmationDialog = (value, type) => {
    if (type === "open") {
      setConfirmationDialog(() => ({ open: true, toConfirm: value }));
    }
    if (type === "close") {
      setConfirmationDialog(() => ({ open: false, toConfirm: null }));
    }
  };
  const handleDeleteRefillCategory = () => {
    const { _id } = refillCategory;
    handleConfirmationDialog({}, "close");
    setDeleteLoading((prev) => ({ ...prev, [_id]: true }));
    laboratoryServices
      .deleteProductsRefillCategory({
        token: authState.token,
        laboratoryId: authState.user.laboratory._id,
        productRefillCategoryId: _id,
      })
      .then((res) => {
        const { status, response } = res;
        if (status === 200) {
          setRefillCategories((prev) => prev.filter((c) => c._id !== _id));
          setToast({ open: "true", message: "Categoria eliminada con exito" });
          return;
        }
        setToast({
          open: "true",
          message: "No se ha podido eliminar la categoria",
        });
      })
      .finally(() => {        
        setDeleteLoading((prev) => {
          const { [_id]:_, ...rest } = prev;
          return rest;
        });
      });
  };

  async function getRefillCategories(params) {
    laboratoryServices
      .getRefillCategories({
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      })
      .then((res) => {
        if (res.status === 200) {
          const categories = res.response;
          setRefillCategories(categories || []);
          const hasBasalCategory =
            categories?.some((cat) => cat.type === "basal") ?? false;
          existsBasalCategory.current = hasBasalCategory;
        } else {
          setToast(() => ({ open: true, message: "Ha ocurrido un error" }));
        }
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    getRefillCategories();
  }, []);
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        <Toast
          open={toast.open}
          message={toast.message}
          close={() => setToast({open:false, message:''})}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              onFilter={(toFilter) => {}}
              noSearchBar
            />
          </Container>
          <Container maxWidth={"lg"} component={"main"}>
            <Box display={"flex"} justifyContent={"end"}>
              <LinkButton
                variant="outlined"
                color="default"
                to={{
                  pathname: "/refill/create/",
                  search: `?b=${existsBasalCategory.current}`,
                }}
              >
                <Typography
                  component={"span"}
                  style={{ display: "flex", gap: 4, alignItems: "center" }}
                >
                  <AddRoundedIcon fontSize="small" />
                  Nueva categoría
                </Typography>
              </LinkButton>
            </Box>
            {loading ? (
              <Box display={"flex"} justifyContent={"center"}>
                <CircularProgress />
              </Box>
            ) : (
              <RefillCategoryTable
                data={refillCategories}
                handleOnDelete={(selectedCategory) => {
                  handleConfirmationDialog(selectedCategory, "open");
                }}
                deleteLoading={deleteLoading}
              />
            )}

            <ConfirmationDialog
              open={confirmationDialog.open}
              onClose={() => handleConfirmationDialog({}, "close")}
              onConfirm={handleDeleteRefillCategory}
              title={"Eliminar categoria"}
            >
              <Box>
                <Typography>¿Está seguro que desea eliminar?</Typography>
                <Card style={{ marginBlock: 12 }} elevation={2}>
                  <CardContent>
                    <Typography
                      className={classes.title}
                      color="textSecondary"
                      gutterBottom
                    >
                      Categoría
                    </Typography>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{ textTransform: "capitalize" }}
                    >
                      {refillCategory?.name}
                    </Typography>
                      <ToggleStatus
                        active={refillCategory?.status}
                        onClick={() => {}}
                      />
                  </CardContent>
                </Card>
              </Box>
            </ConfirmationDialog>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    "& main": {
      flexGrow: 1,
    },
    "& .MuiPaper-root": {
      boxShadow: "none !important",
    },
  },
}));
